import React, { useRef } from "react";
import styles from "./UserImage.module.scss";
import unknownUser from "../../../../assets/icons/vector/unknowUser.svg";
import { usePost } from "hooks/usePost";
import { userEndpoints } from "hooks/endpoints";
import LoadingSpinner from "component/Custom/LoadingSpinner/LoadingSpinner";
import SvgWithBranding from "component/hoc/branding/withBrandingColor.hoc";
import { useUserContext } from "app-context/user/UserContext";

const UserImage = ({ userImage, edit, refetch }) => {
  const fileInputRef = useRef(null);
  const { updateProfileImage } = useUserContext();

  const { mutate: UploadImage, isPending } = usePost({
    onSuccessToast: "Uploaded Successfully",
    toastType: "add",
  });

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      if (file.size <= 5 * 1024 * 1024) {
        const formData = new FormData();
        formData.append("FileToUpload", file);

        UploadImage(
          {
            url: userEndpoints?.uploadProfilePicture(),
            data: formData,
            isFormData: true,
          },
          {
            onSuccess: () => {
              updateProfileImage(file);
              if (refetch) refetch();
            },
            onError: (error) => {
              console.error("Upload failed:", error);
            },
          }
        );
      } else {
        console.error("File is too large. Max size is 5MB.");
        event.target.value = null;
      }
    }
  };

  const handleSelectImage = () => {
    fileInputRef.current.click();
  };

  return (
    <div className={styles["cont"]}>
      <div className={styles["parent"]}>
        {userImage ? (
          <img
            src={`data:image/jpeg;base64,${userImage}`}
            className={styles["user-image"]}
            alt='User'
          />
        ) : (
          <img
            src={unknownUser}
            alt='User Icon'
            className={styles["user-image"]}
          />
        )}

        {edit && (
          <>
            <input
              type='file'
              accept='image/*'
              style={{ display: "none" }}
              ref={fileInputRef}
              onChange={handleImageChange}
            />
            {isPending ? (
              <LoadingSpinner showSpinner />
            ) : (
              <span className={styles["child"]} onClick={handleSelectImage}>
                <SvgWithBranding type='camera' className={styles.icon} />
              </span>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default UserImage;
